<template xmlns="http://www.w3.org/1999/html">
    <div id="home" class="w1440">
        <zxHead></zxHead>
        <div class="home">
            <zxTabbar :tabbarIndex='0'></zxTabbar>
            <div class="content">
                <div class="flexbox">
                    <div class="userbox">
                        <div class="msg" @click="userClick">
                            <p class="imgbox"><img src="@/assets/Solid _ Communication _User@2x.png" alt=""></p>
                            <span>{{chooseUserName}}</span>
                        </div>
                        <div v-show="userStatus" class="tc" >
                            <p class="userboxtitle">账户</p>
                            <div class="userList">
                              <ul v-clickoutside="userStatusfun">
                                <li v-for="(item,index) in user" :key="index" :class="item.userName==username?'on':''" @click="selectUser(item)">
                                    <span>{{item.nickName}}</span>
                                </li>
                              </ul>
                            </div>
                            <div class="loadMore"><i class="el-icon-arrow-down"></i></div>
                        </div>
                    </div>
                    <div class="calendarbox">
                        <div @click="calendarstatus=!calendarstatus" class="calendartimebox">
                            <p>
                                <span>{{time.startTime.slice(5)}}</span> - <span>{{time.endTime.slice(5)}}</span>
                            </p>
                            <img src="@/assets/akar-icons_chevron-down.png" alt="">
                        </div>
                        <div v-if="calendarstatus" class="zx-calendar" v-clickoutside="handleClickOutside">
                            <calendar @selectTime="selectTime" :start_time="time.startTime" :end_time="time.endTime"></calendar>
                        </div>
                    </div>
                </div>
                <div class="chat">
                    <div class="chatleft" id="charts"></div>
                    <div class="chatright">
                        <ul class="chatrightul">
                            <li class="chatrightli">
                                <div class="top">
                                    <div class="topbox">
                                        <p class="icon"><img src="@/assets/bag-tick-2.png" alt=""></p>
                                        <p class="tip" v-show="configData.showBalanceNotEnough">余额不足</p>
                                    </div>
                                    <div class="topbox">
                                        <p class="icon" @click="showPayLevel"><i class="el-icon-more"></i></p>
                                        <div class="rechargeDialog" v-show="dialogVisible" v-clickoutside="dialogVisiblefun">
                                            <p class="userboxtitle">账户</p>
                                            <ul>
                                                <li v-for="(item,index) in recharge" :key="index" @click="selectRecharge(item)">
                                                    <span>{{item.amount}}元</span>
                                                    <span>{{item.level}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="name">余额</div>
                                <div class="num" >￥{{configData.balance}}</div>
                            </li>
                            <li class="chatrightli">
                                <div class="top">
                                    <p class="icon"><img src="@/assets/vuesax_bold_wallet-3.png" alt=""></p>
                                </div>
                                <div class="name">消耗金额</div>
                                <div class="num">￥{{configData.totalConsumption}}</div>
                            </li>
                            <li class="chatrightli">
                                <div class="top">
                                    <p class="icon"><img src="@/assets/7f29da99de4bf274300a8f1e98a7f74.png" alt=""></p>
                                </div>
                                <div class="name">点击数</div>
                                <div class="num">{{configData.totalClicks}}</div>
                            </li>
                            <li class="chatrightli">
                                <div class="top">
                                    <p class="icon"><img src="@/assets/vuesax_bold_wallet.png" alt=""></p>
                                </div>
                                <div class="name">转化数</div>
                                <div class="num">{{configData.totalConversions}}</div>
                            </li>
                        </ul>
                    </div>
                </div>
              <!-- 表格数据 -->
                <div class="table">
                    <div class="tableleft">
                        <ul class="tabletitle">
                            <li class="title">
                                二维码设置
                            </li>
                            <li class="fun">
                                <p class="del" @click="removeGroupAndQrCodeConfig">删除</p>
                                <div class="filterbox" >
                                    <p class="filter">
                                        <img src="@/assets/vuesax_bold_filter.png" alt="" @click="showAllGroupList">
                                    </p>
                                    <div class="groupDialog" v-show="group.dataDialog" v-clickoutside="groupClickOutSide">
                                        <div class="groupDialogbox">
                                            <p class="userboxtitle">分组信息</p>
                                            <p class="add">
                                                <img src="@/assets/Solid_Interface _Plus.png" alt="" @click="groupAddClick">
                                            </p>
                                            <div class="renameDialog" v-show="group.addDialog || group.editDialog" v-clickoutside="renameDialogfun">
                                                <ul>
                                                    <li class="name">分组名称：</li>
                                                    <li><input v-model="group.name" type="text" @keyup.enter="renameGroup"></li>
                                                </ul>
                                            </div>
                                            <ul class="list">
                                                <li v-for="(item,index) in group.downList" :key="index" >
                                                    <div class="msg">
                                                        <p class="msgleft">
                                                            <span>{{index+1}}</span>
                                                            <span>{{item.name}}</span>
                                                        </p>
                                                        <p class="msgright">{{item.qrCodeNum}}</p>
                                                    </div>
                                                    <div class="button">
                                                        <img src="@/assets/Vector2.png" alt="" class="more" @click="groupEditClick(item)">
                                                        <img src="@/assets/del.png" alt="" class="delbutton" @click="groupDelClick(item)">
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <p class="search">
                                    <img src="@/assets/search.png" alt="" @click="groupList">
                                    <input type="text" v-model="group.search" placeholder="搜索">
                                </p>
                            </li>
                        </ul>

                        <div class="tablebox">
                            <ul class="tableboxtitle line">
                                <li>分组</li>
                                <li>二维码图片</li>
                                <li>二维码名称</li>
                                <li>二维码数量</li>
                                <li>备注</li>
                                <li>开关状态</li>
                            </ul>
                            <div>
                                <el-scrollbar ref="scrollMenuRef" class="scrollMenuBox" wrap-style="overflow-x:hidden;">
                                    <div v-for="(item,index) in group.data" :key="index" class="boxshow" @click="showIndex=index">
                                        <img src="@/assets/Vector.png" alt="" :class="['show',showIndex==index?'on':'']">
                                        <ul class="tableboxtitle ">
                                            <li>
                                                <el-checkbox v-model="item.checked" @change="checkGroup(item)"></el-checkbox>
                                                <span style="margin-left:8px">{{item.groupName}}</span>
                                            </li>
                                            <li></li>
                                            <li></li>
                                            <li>{{item.qrCodeNum}}</li>
                                            <li style="position: relative;">
                                              <el-tooltip :content="item.remark" placement="top">
                                                <span class="ellipsis" style="position: relative;display: block;">{{item.remark}}</span>
                                              </el-tooltip>
                                            </li>
                                            <li></li>
                                        </ul>
                                        <div v-if="showIndex==index" class="childbox">
                                            <!-- <el-checkbox-group > -->
                                            <ul class="tableboxtitle" v-for="(list,i) in item.qrCodeList" :key="i">
                                                <li>
                                                    <el-checkbox v-model="list.checked" @change="checkQrCodeConfig(list)"></el-checkbox>
                                                </li>
                                                <li><img :src="list.fileUrl" alt="" class="qrcode"></li>
                                                <li>
                                                  <el-tooltip :content="list.qrCodeName" placement="top">
                                                    <span class="ellipsis" style="position: relative;display: block;">{{list.qrCodeName}}</span>
                                                  </el-tooltip>
                                                </li>
                                                <li></li>
                                                <li style="position: relative;">
                                                  <el-tooltip :content="list.remark" placement="top">
                                                    <span class="ellipsis" style="position: relative;display: block;">{{list.remark}}</span>
                                                  </el-tooltip>
                                                </li>
                                                <li>
                                                    <el-switch v-model="list.isAvailable" :active-value='1' :inactive-value='0' :width="44" @change="switchQrCodeConfig(list)"></el-switch>
                                                    <img src="@/assets/Vector2.png" alt="" @click="qrCodeConfigEditClick(list)">
                                                </li>
                                            </ul>
                                            <!-- </el-checkbox-group> -->
                                        </div>

                                    </div>
                                </el-scrollbar>
                            </div>
                        </div>
                    </div>
                    <div class="tableright">
                        <p class="title">操作看板</p>
                        <p class="subtitle">二维码链接</p>
                        <div class="box1">
                            <p>{{qrCodeUrl.show.url}}</p>
                            <img src="@/assets/copy.png" alt="" class="copy"  @click="copy(qrCodeUrl.show.url)">
                        </div>
                        <p class="subtitle">投放链接</p>
                        <div class="borderbox" style="margin-bottom: 30px;">
                            <div class="box1">
                                <p>{{landingPage.url.show.url}}</p>
                                <img src="@/assets/down.png" alt="" class="down" @click="landingPage.url.listDialog=!landingPage.url.listDialog">
                                <img src="@/assets/copy.png" alt="" class="copy" @click="copy(landingPage.url.show.url)">
                                <ul class="putinDialog" v-show="landingPage.url.listDialog" v-clickoutside="hideLandingPageUrlList">
                                    <li v-for="(item,index) in landingPage.url.data" :key="index" >
                                        <span>{{item.url}}</span>
                                        <img src="@/assets/copy.png" alt=""  @click="copy(item.url)">
                                        <img src="@/assets/del.png" alt="" @click="landingPageUrlDelOperation(item)" >
                                    </li>
                                </ul>
                            </div>
                            <div class="box2" @click="kefuClick">
                                企微客服链接配置
                                <ul class="linkDialog" v-show="kefu.listDialog" v-clickoutside="hideKefuList">
                                    <li v-for="(item,index) in kefu.data" :key="index" >
                                        <div class="msg">
                                            {{item.link}}
                                        </div>
                                        <div class="button">
                                            <img src="@/assets/Vector2.png" alt="" class="Vector">
                                            <el-switch v-model="item.isAvailable" :active-value=1 :inactive-value=0 :width="44" @change="switchKefuConfig(item)"></el-switch>
                                            <img src="@/assets/del.png" alt="" class="del">
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="borderbox" style="margin-bottom: 10px;">
                            <div class="box3">
                                <p class="title">跳转按钮时间设置</p>
                                <div class="time">
                                    <el-switch v-model="landingPage.operationConfig.jumpTimeOut.data.isOpen" :active-value=1 :inactive-value=0 @change='switchLandingPageOperation' :width="44"></el-switch>
                                    <span class="on">开启</span>
                                    <el-select v-model="landingPage.operationConfig.jumpTimeOut.selectedValue" size="mini" placeholder="请选择" @change="changeLandingPageOperation(1)">
                                      <el-option v-for="(item, index) in landingPage.operationConfig.jumpTimeOut.downList"
                                                 :key="index" :value="item.code" :label="item.value"/>
                                    </el-select>
                                    秒
                                </div>
                                <p class="tip">跳转时间为1秒时，计划容易出现审核建议，可以优先设置为10-30秒，或关闭自动跳转，等待计划审核通过之后再设置跳转时间</p>
                            </div>
                        </div>
                        <div class="borderbox">
                            <div class="box4">
                                <div class="title">
                                    <span class="titleSpan">转化目标</span>
                                    <el-select v-model="landingPage.operationConfig.convertTarget.selectedValue" style="width:100px;" size="small" @change="changeLandingPageOperation(2)">
                                      <el-option v-for="(item, index) in landingPage.operationConfig.convertTarget.downList"
                                        :key="index" :value="item.code" :label="item.value"
                                      />
<!--                                        <el-option value="微信复制">微信复制</el-option>-->
<!--                                        <el-option value="微信_添加企业微信">微信_添加企业微信</el-option>-->
<!--                                        <el-option value="表单提交">表单提交</el-option>-->
                                    </el-select>
                                </div>
                                <p class="tip">转化目标对应的是巨量引擎后台的转化目标，如果修改之后，巨量引擎的计划也需要同步更换</p>
                            </div>
                        </div>
                        <div class="addButton" @click="qrCodeConfigAddClick">
                            <img src="@/assets/Path.png" alt="">
                            <span>添加二维码</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            custom-class="qrcodeDialog"
            title="请使用微信扫码支付"
            :visible.sync="qrcodeDialog"
            width="26%"
        >
            <img :src="qecode" alt="" width="80%" style="margin:0 auto;display:block">
        </el-dialog>
        <el-dialog
            custom-class="addRqcodeDialog"
            :visible.sync="qrCodeConfig.addDialog"
            :show-close="false"
            width="24%"
            :before-close="closeQrCodeConfigDialog"
        >
          <div class="">
            <el-upload class="upload-demo"
                :multiple="false"
                :limit="1"
                :before-upload="beforeUpload"
                :show-file-list="true"
                :file-list="qrCodeConfig.uploadFileList"
                action=""
                :on-exceed="handleExceed"
                :on-remove="handleRemove"
                :on-change="handleChange"
                :on-preview="handlePreview"
                :http-request="uploadSubmit"
                >
                <template #trigger>
                  <img src="@/assets/upload.png" alt="">
                  <div class="el-upload__text">上传二维码图片</div>
                  <div class="el-upload__tip">支持jpg、png格式，图片大小需要在100kb以内</div>
                  <img v-if='qrCodeConfig.addData.url' :src="qrCodeConfig.addData.url" alt="">
                </template>
            </el-upload>
          </div>
          <div class="form">
                <div class="formbox">
                  <el-select v-model="qrCodeConfig.addData.groupCode" placeholder="请选择分组">
                    <el-option v-for="item in group.downList" :key="item.code" :label="item.name" :value="item.code"/>
                  </el-select>
<!--                    分组:-->
<!--                    <input type="text" placeholder="最多10个字" v-model="form.group">-->
<!--                    <img src="@/assets/Vector.png" alt="" @click="addgroupDialog=true">-->
<!--                    <div v-show="addgroupDialog" class="addgroupDialog">-->
<!--                        <p class="userboxtitle">选择分组</p>-->
<!--                        <ul>-->
<!--                            <li v-for="(item,index) in group.downList" :key="index" @click="selectgroup(item.name)">-->
<!--                                <span>{{item.code}}</span>-->
<!--                                <span>{{item.name}}</span>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->

                </div>
                <div class="formbox">
                    二维码名称:
                    <input type="text" placeholder="最多10个字" v-model="qrCodeConfig.addData.qrCodeName">
                </div>
                <div class="formbox">
                    二维码备注:
                    <textarea placeholder="最多50个字" v-model="qrCodeConfig.addData.remark"></textarea>
                </div>
            </div>
            <div class="button" @click="qrCodeConfigAddOperation()">完成新建</div>
        </el-dialog>
        <el-dialog
            custom-class="editgroupDialog"
            :visible.sync="qrCodeConfig.editDialog"
            :show-close="true"
            title="二维码编辑"
            width="24%"
            :before-close="closeQrCodeConfigDialog"
        >
            <div class="qrcode">
                <el-upload
                class="upload-demo"
                :multiple="false"
                :limit="1"
                :show-file-list="true"
                :file-list="qrCodeConfig.uploadFileList"
                :on-exceed="handleExceed"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :on-preview="handlePreview"
                :http-request="uploadSubmit"
                action="">
                    <p>点击替换二维码</p>
                </el-upload>
                <img v-if='qrCodeConfig.editData.fileUrl' :src="qrCodeConfig.editData.fileUrl" alt="">
            </div>
            <div class="form">
                <div class="formbox">
                  <el-select v-model="qrCodeConfig.editData.groupCode" placeholder="请选择分组">
                    <el-option v-for="item in group.downList" :key="item.code" :label="item.name" :value="item.code"/>
                  </el-select>
<!--                    分组:-->
<!--                    <input type="text" placeholder="最多10个字" v-model="editform.group">-->
<!--                    <img src="@/assets/Vector.png" alt="" @click="add2groupDialog=true">-->
<!--                    <div v-show="add2groupDialog" class="addgroupDialog">-->
<!--                        <p class="userboxtitle">修改分组</p>-->
<!--                        <ul>-->
<!--                            <li v-for="(item,index) in group.data" :key="index" @click="selectgroup(item.name)">-->
<!--                                <span>{{item.code}}</span>-->
<!--                                <span>{{item.name}}</span>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
                </div>
                <div class="formbox">
                    二维码名称:
                    <input type="text" placeholder="最多10个字" v-model="qrCodeConfig.editData.qrCodeName">
                </div>
                <div class="formbox">
                    二维码备注:
                    <textarea placeholder="最多50个字" v-model="qrCodeConfig.editData.remark"></textarea>
                </div>
            </div>
            <div class="button">
                <div class="save" @click="qrCodeConfigEditOperation">保存</div>
                <div class="del">删除</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

var _this
import zxHead from '@/components/head'
import zxTabbar from '@/components/tabbar'
import calendar from '@/components/calendar'
import Clickoutside from 'element-ui/src/utils/clickoutside'
import {Message, Loading, Tooltip } from 'element-ui'
import {getDay} from "@/util/fun";
import {getUsersExcludeAdmin} from '@/api/login';
import {statisticsIndexByTime, statisticsGroupByTime} from "@/api/index/statistics";
import {addGroup, editGroup, delGroup, delGroups, pageGroup, downListGroup} from '@/api/group/group'
import {addQrCodeConfig, editQrCodeConfig,delQrCodeConfigs, enableQrCodeConfig, disableQrCodeConfig} from '@/api/qrcode/qrCodeConfig'
import {uploadFile} from '@/api/file/file';
import {delLandingPageUrl, landingPageUrlList} from '@/api/landing-page/landingPageUrl';
import {landingPageOperationList, editLandingPageOperation, enableLandingPageOperation, disableLandingPageOperation, landingPageOperationDownList} from '@/api/landing-page/landingPageOperation';
import {qrCodeUrlList} from '@/api/qrcode/qrCodeUrl';
import {kefuList, enableKefu, disableKefu} from '@/api/kefu/kefu';
import {payLevel, pay} from '@/api/pay/pay';
export default {

  directives: { Clickoutside, Tooltip },
    components:{
        zxHead,
        zxTabbar,
        calendar
    },
    data(){
        return {
            userStatus:false,
            userId: null,
            loginUserName: "",
            chooseUserName: "",
            username:"",
            // 是否管理员账户
            adminRole: false,
            // 用户列表
            user:[

            ],
            // 时间段查询条件
            time:{
              startTime: getDay(0),
              endTime: getDay(0),
            },
            // echarts点击数据
            click_num_line:[
              [5,100],
              [6,200],
              [7,120],
              [8,170],
              [9,240],
              [10,300],
              [11,400]
            ],
            // echarts转换数据
            conversions_num_line:[
              [5,200],
              [6,300],
              [7,80],
              [8,250],
              [9,290],
              [10,400],
              [11,300]
            ],
            // 首页展示信息
            configData:{
              totalClicks: null,//点击数
              totalConversions: null,//转化数
              totalConsumption: null,//消耗金额
              balance: null,//余额
              showBalanceNotEnough: false//是否显示余额不足
            },
            group: {
              // 数据弹框
              dataDialog: false,
              // 添加弹框
              addDialog: false,
              // 修改弹框
              editDialog: false,
              // 新增或者修改的分组值
              name: '',
              // 选中的数据
              choose: {
                groupCode: '',
                groupName: '',
                remark: ''
              },
              operation: null,
              // 展示的列表数据
              data: [{
                groupCode:"",
                groupName:"",
                qrCodeNum:1,
                isAvailable: 1,
                remark: "",
                qrCodeList:[{
                  qrCodeNo: "",
                  qrCodeName: "",
                  groupCode: "",
                  groupName: "",
                  userName: "",
                  remark: "",
                  fileUrl: "",
                  isAvailable: ""
                }]}],
              // 搜索条件
              search: '',
              // 分组数据展示，以及下拉分组展示
              downList:[{
                code: "",
                name: "",
                qrCodeNum: 1
              }]
            },
            qrCodeConfig:{
              addDialog: false,
              addData: {
                userName: '',
                fileCode: '',
                groupCode: '',
                qrCodeName: '',
                remark: ''
              },
              editDialog: false,
              editData: {
                qrCodeNo: '',
                fileCode: '',
                groupCode: '',
                qrCodeName: '',
                remark: ''
              },
              uploadFileList: [],
              // 上传的文件结果
              uploadFileResult: null,
              // 支持上传的类型
              supportUploadType: ['jpg', 'jpeg', 'png','gif','webp']
            },
            landingPage: {
              url: {
                data:[{
                  code: '',
                  userName: '',
                  url: ''
                }],
                show: {
                  code: '',
                  userName: '',
                  url: ''
                },
                // 下拉落地页展示
                listDialog: false
              },
              operationConfig: {
                jumpTimeOut: {
                  data: {
                    operationType: 1,
                    isOpen: 1,
                    operationName: '30',
                  },
                  // 选中的值
                  selectedValue: "",
                  downList: [
                    {code: '', name: ''}
                  ]
                },
                convertTarget: {
                  data: {
                    code: '',
                    operationType: 1,
                    value: 'wechat',
                    operationName: '微信'
                  },
                  // 选中的值
                  selectedValue: "",
                  downList: [
                    {code: '', name: ''}
                  ]
                }
              }
            },
            qrCodeUrl: {
              show: {},
              data: []
            },
            kefu: {
              listDialog: false,
              data: [
                  {
                    uri: ''
                  }
              ]
            },
            editform:{
                image:require("@/assets/qrcode.png"),
                group:"",
                name:"",
                remake:"",
            },
            addRqcodeDialog:false,
            add2groupDialog:false,
            link:[
                {
                    name:"kfcfee0fbea003c78e7",
                    status:0,
                },
                {
                    name:"kfcfee0fbea003c78e7",
                    status:0,
                },
                {
                    name:"kfcfee0fbea003c78e7",
                    status:0,
                },
                {
                    name:"kfcfee0fbea003c78e7",
                    status:0,
                }
            ],
            putinDialog:false,
            putin:[
                'https://liangyun.xylycloud.com/wakeup/wakeup',
                'https://liangyun.xylycloud.com/wakeup/wakeup',
                'https://liangyun.xylycloud.com/wakeup/wakeup',
                'https://liangyun.xylycloud.com/wakeup/wakeup'
            ],
            renameDialog:false,
            groupDialog:false,
            qecode:require("@/assets/qrcode.png"),
            qrcodeDialog:false,
            // 充值档位
            recharge:[

            ],
            dialogVisible:false,

            status:true,
            target:"微信复制",
            calendarstatus:false,

            jumptime:'1',

            showIndex:-1,
            qrcode:[
                {
                    group:"老平组",
                    qrcodeNum:7,
                    remake:12,
                    qrcode:[
                        {
                            id:1,
                            name:"A组",
                            remake:12,
                            status:1,
                            image:require("@/assets/qrcode.png")
                        },
                        {
                            id:2,
                            name:"老R18号",
                            remake:12,
                            status:1,
                            image:require("@/assets/qrcode.png")
                        }
                    ]
                },
                {
                    group:"老平组",
                    qrcodeNum:7,
                    remake:12,
                    qrcode:[
                        {
                            id:1,
                            name:"A组",
                            remake:12,
                            status:1,
                            image:require("@/assets/qrcode.png")
                        },
                        {
                            id:2,
                            name:"老R18号",
                            remake:12,
                            status:1,
                            image:require("@/assets/qrcode.png")
                        }
                    ]
                },
                {
                    group:"老平组",
                    qrcodeNum:7,
                    remake:12,
                    qrcode:[
                        {
                            id:1,
                            name:"A组",
                            remake:12,
                            status:1,
                            image:require("@/assets/qrcode.png")
                        },
                        {
                            id:2,
                            name:"老R18号",
                            remake:12,
                            status:1,
                            image:require("@/assets/qrcode.png")
                        },
                        {
                            id:1,
                            name:"A组",
                            remake:12,
                            status:1,
                            image:require("@/assets/qrcode.png")
                        },
                        {
                            id:2,
                            name:"老R18号",
                            remake:12,
                            status:1,
                            image:require("@/assets/qrcode.png")
                        }
                    ]
                }
            ],
        }
    },
    mounted() {
        _this = this;
        _this.group.downList = [];
        _this.userId = _this.$store.getters.userId;
        _this.loginUserName = _this.$store.getters.name;
        _this.username = _this.loginUserName;
        _this.adminRole = _this.$store.getters.adminRole;
        if (!_this.adminRole) {
          _this.user = [];
          _this.init();
          _this.userStatus = false;
          _this.chooseUserName = _this.loginUserName;
        } else {
          // 管理员
          getUsersExcludeAdmin().then(res => {
            _this.user = res.data;
            if (_this.user) {
              _this.selectUser(_this.user[0]);
            }
          })
        }

    },
    methods: {
        /*---------------------初始化----------------------------*/
        init() {
          _this.statisticsIndex();
          _this.statisticsGroup();
          _this.groupList();
          _this.landingPageUrlShowListOperation();
          _this.landingPageOperationDownList1();
          _this.qrCodeUrlShowListOperation();
        },
        /*---------------------用户条件---------------------------*/
        userClick() {
          if (_this.adminRole) {
            _this.userStatus = !_this.userStatus;
          } else {
            _this.userStatus = false;
          }
        },
        /*----------------充值档位-------------------------------*/
        showPayLevel() {
          payLevel().then(res => {
              if (res.ok) {
                _this.recharge = res.data;
                _this.dialogVisible = true;
              } else {
                Message({type: 'error', message: res.msg});
              }
          })
        },
        /*---------------设置事件条件-----------------------------*/
        timeConvert() {
          return {
            startTimeStamp: new Date(_this.time.startTime + " 00:00:00").getTime() / 1000,
            endTimeStamp: new Date(_this.time.endTime + " 23:59:59").getTime() / 1000
          };
        },
        /*----------刷新统计数据----------------------------------------*/
        refreshStatistics() {
          _this.statisticsIndex();
          _this.statisticsGroup();
        },
        /*---------------------统计---------------------------------------*/
        statisticsIndex() {
          let data = _this.timeConvert();
          data.userId = _this.userId;
          statisticsIndexByTime(data).then(res => {
            _this.configData = res.data;
          })
        },
        statisticsGroup() {
          let data = _this.timeConvert();
          data.userId = _this.userId;
          statisticsGroupByTime(data).then(res => {
            _this.drawChart(_this.buildChartData(res.data));
          })
        },
        /*----------------------组---------------------------------------*/
        groupList() {
          pageGroup({
            pageNo: 1,
            pageSize: 1000,
            search: {
              userName: _this.username,
              queryLikeGroupName: _this.group.search
            }
          }).then(res => {
            _this.group.data = res.data.data;
          })
        },
        showAllGroupList() {
          _this.group.dataDialog = true;
          _this.groupDownList();
        },
        groupDownList() {
          downListGroup({
            userName: _this.username
          }).then(res => {
            _this.group.downList = res.data;
          })
        },
        groupClickOutSide() {
          _this.group.dataDialog = false;
        },
        groupAddClick() {
          _this.group.addDialog = true;
          _this.group.operation = 'add';
        },
        groupEditClick(item) {
            _this.group.choose = item;
            _this.group.editDialog = true;
            _this.group.operation = 'edit';
        },
        groupDelClick(item) {
          _this.group.choose = item;
          delGroup({
            'code': item.groupCode
          }).then(res => {
            _this.operation = null;
            Message({type: 'success', message: '删除分组成功'});
            _this.groupList();
          })
        },
        renameGroup(e) {
          if (e.key != 'Enter') {
            return;
          }
          if (_this.group.operation === 'add') {
            _this.groupAddOperation();
          } else if (_this.group.operation === 'edit') {
            _this.groupEditOperation();
          }
        },
        groupAddOperation() {
          addGroup({
            userName: _this.username,
            groupName: _this.group.name,
            remark: '测试分组'
          }).then(res => {
            _this.group.addDialog = false;
            _this.group.operation = null;
            _this.group.choose = {};
            _this.group.name = '';
            Message({type: 'success', message: '新增分组成功'});
            _this.groupList();
          })
        },
        groupEditOperation() {
          editGroup({
            groupCode: _this.group.choose.groupCode,
            userName: _this.username,
            groupName: _this.group.name
          }).then(res => {
            _this.group.editDialog = false;
            _this.group.operation = null;
            _this.group.choose = {};
            _this.group.name = '';
            Message({type: 'success', message: '修改分组成功'});
            _this.groupList();
          })
        },
        checkGroup(item) {
          let checked = item.checked;
          item.checked = checked;
          item.qrCodeList.forEach(
              e => e.checked = checked
          )
        },
      checkQrCodeConfig(item) {
          let checked = item.checked;
          let group;
        for (let i = 0; i < _this.group.data.length; i++) {
          let g = _this.group.data[i];
          if (g.groupCode === item.groupCode) {
            group = g;
            break;
          }
        }
        let checkSize = 0;
        for (let i = 0; i < group.qrCodeList.length; i++) {
          let qc = group.qrCodeList[i];
          if (qc.checked === checked) {
            checkSize++;
          }
        }
        if (group.qrCodeList.length === checkSize) {
          group.checked = checked;
        }
      },
      switchQrCodeConfig(item) {
          // 使用change事件，会先更改v-model绑定的值，在调用change事件
          if (item.isAvailable === 0) {
            disableQrCodeConfig({code: item.qrCodeNo}).then(res => {
              Message({type: 'success', message: '禁用二维码成功'});
            });
          } else {
            enableQrCodeConfig({code: item.qrCodeNo}).then(res => {
              Message({type: 'success', message: '启用二维码成功'});
            });
          }
        },
      /*----------------------------------二维码配置----------------------------*/
      /**
       * 点击二维码新增时触发
       */
      qrCodeConfigAddClick() {
          _this.qrCodeConfig.addDialog = true;
          if (_this.group.downList.length === 0) {
            _this.showAllGroupList();
          }
        },
      qrCodeConfigEditClick(item) {
        _this.qrCodeConfig.editDialog = true;
        if (_this.group.downList.length === 0) {
          _this.showAllGroupList();
        }
        _this.qrCodeConfig.editData = Object.assign({}, item);
      },
      removeGroupAndQrCodeConfig() {
        let gs = [];
        let qrs = [];
        for (let i = 0; i < _this.group.data.length; i++) {
          let g = _this.group.data[i];
          if (g.checked) {
            gs.push(g.groupCode);
          }
          if (g.qrCodeList) {
            for (let j = 0; j < g.qrCodeList.length; j++) {
              let qr = g.qrCodeList[j];
              if (qr.checked) {
                qrs.push(qr.qrCodeNo);
              }
            }
          }
        }
        let removeSuccess = false;
        if (gs.length > 0) {
          delGroups(gs).then(res => {
            removeSuccess = true;
          });
        }
        if (qrs.length > 0) {
          delQrCodeConfigs(qrs).then(res => {
            removeSuccess = true;
          });
        }
        setTimeout(() => {
            if (removeSuccess) {
              _this.groupList();
            }
        }, 1000);
      },
      /*---------------------------文件上传---------------------------------*/
      /**
       * 校验上传文件大小
        * @param file
       * @returns {boolean}
       */
      beforeUpload(file) {
          if (!file) {
            return false;
          }
          let isLt1M = file.size / 1024 / 1014 < 11;
          if (!isLt1M) {
            Message({type:'error', message: '上传文件大小不能超过 10MB!'});
            return false;
          }
          let contain = false;
        for (let i = 0; i < _this.qrCodeConfig.supportUploadType.length; i++) {
          let support = _this.qrCodeConfig.supportUploadType[i];
          if (file.type && file.type.indexOf(support) > -1) {
            contain = true;
          }
        }
        if (!contain) {
          Message({type:'error', message: '不支持的上传文件类型'});
          return false;
        }
        return isLt1M;
      },
      handleExceed() {
        Message({type: 'error', message: '只能选择一个文件进行上传'});
      },
      handleChange(file, fileList) {
        _this.qrCodeConfig.uploadFileList = fileList;
        _this.qrCodeConfig.addData.url = '';
        _this.qrCodeConfig.editData.fileUrl = '';
      },
      handleRemove(file, fileList) {
        _this.qrCodeConfig.uploadFileList = fileList;
        _this.qrCodeConfig.addData.url = '';
        _this.qrCodeConfig.editData.fileUrl = '';
      },
        /**
         * 预览文件
         * @param file
         */
        handlePreview(file) {
          //_this.qrCodeConfig.addData.url = _this.qrCodeConfig.uploadFileResult.url;
          //_this.qrCodeConfig.editData.fileUrl = _this.qrCodeConfig.uploadFileResult.url;
        },
        uploadSubmit(file) {
          if (_this.qrCodeConfig.uploadFileList.length === 0) {
            Message({type: 'error', message: '请先选择上传的文件'});
            return;
          }
          let formData = new FormData();
          formData.append('file', file.file);
          const loading = this.$loading({
            lock: true,
            text: '上传中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          uploadFile({
            file: formData,
            remark: '测试上传'
          }).then(res => {
            loading.close();
            _this.qrCodeConfig.uploadFileResult = res.data;
            _this.qrCodeConfig.addData.url = _this.qrCodeConfig.uploadFileResult.url;
            _this.qrCodeConfig.editData.fileUrl = _this.qrCodeConfig.uploadFileResult.url;
          }).catch(e => {
            loading.close();
          })
        },
      closeQrCodeConfigDialog(done){
            _this.qrCodeConfig.addDialog = false;
            _this.qrCodeConfig.addData = {};
            _this.qrCodeConfig.editDialog = false;
            _this.qrCodeConfig.editData = {};
            _this.qrCodeConfig.uploadFileList=[];
            _this.qrCodeConfig.uploadFileResult={};
            done();
        },
        /*---------------------落地页----------------------------*/
        landingPageUrlShowListOperation() {
          landingPageUrlList({
            userName: _this.username
          }).then(res => {
            _this.landingPage.url.data = res.data;
            if (res.data.length > 0) {
              _this.landingPage.url.show = res.data[0];
            }
            _this.landingPageOperation();
          })
        },
        landingPageUrlDelOperation(item) {
          delLandingPageUrl({
            code: item.code
          }).then(res => {
            Message({type: "success", message: "删除落地页链接成功"})
            _this.landingPageUrlShowListOperation();
          })
        },
        hideLandingPageUrlList() {
          _this.landingPage.url.listDialog = false;
        },
        landingPageOperationDownList1() {
          landingPageOperationDownList({operationType: 1}).then(res => _this.landingPage.operationConfig.jumpTimeOut.downList = res.data);
          landingPageOperationDownList({operationType: 2}).then(res => _this.landingPage.operationConfig.convertTarget.downList = res.data);
        },
        landingPageOperation() {
          let landingPageShow = _this.landingPage.url.show;
          if (!landingPageShow.code) {
            return;
          }
          let landingPageCode = _this.landingPage.url.show.code;
          landingPageOperationList({
            landingPageCode: landingPageCode
          }).then(res => {
            if (res.data) {
              for (let i = 0; i < res.data.length; i++) {
                let one = res.data[i];
                if (one.operationType == 1) {
                  _this.landingPage.operationConfig.jumpTimeOut.data = one;
                  _this.landingPage.operationConfig.jumpTimeOut.selectedValue = one.value;
                } else if (one.operationType == 2) {
                  _this.landingPage.operationConfig.convertTarget.data = one;
                  _this.landingPage.operationConfig.convertTarget.selectedValue = one.value;
                }
              }
            }
          })
        },
        changeLandingPageOperation(operationType) {
          let item = {};
          if (operationType === 1) {
            item = {
              code: _this.landingPage.operationConfig.jumpTimeOut.data.code,
              value: _this.landingPage.operationConfig.jumpTimeOut.selectedValue};
            for (let i = 0; i < _this.landingPage.operationConfig.jumpTimeOut.downList.length; i++) {
              let downOne = _this.landingPage.operationConfig.jumpTimeOut.downList[i];
              if (downOne.code === item.value) {
                item.operationName = downOne.value;
              }
            }
          } else if (operationType === 2) {
            item = {
              code: _this.landingPage.operationConfig.convertTarget.data.code,
              value: _this.landingPage.operationConfig.convertTarget.selectedValue};
            for (let i = 0; i < _this.landingPage.operationConfig.convertTarget.downList.length; i++) {
              let downOne = _this.landingPage.operationConfig.convertTarget.downList[i];
              if (downOne.code === item.value) {
                item.operationName = downOne.value;
              }
            }
          }
          if (item) {
            editLandingPageOperation(item).then(res => {
              _this.landingPageOperation();
            })
          }
        },
        switchLandingPageOperation() {
          let item = _this.landingPage.operationConfig.jumpTimeOut.data;
          if (item.isOpen == 0) {
            disableLandingPageOperation({code: item.code})
                .then(res => Message({type: 'success', message: '禁用操作成功'}));
          } else {
            enableLandingPageOperation({code: item.code})
                .then(res => Message({type: 'success', message: '启用用操作成功'}));
          }
        },
        /*----------------------------二维码链接---------------------*/
        qrCodeUrlShowListOperation() {
          qrCodeUrlList({
            "userName": _this.username
          }).then(res => {
            if (res.data.length > 0) {
              _this.qrCodeUrl.data = res.data;
              _this.qrCodeUrl.show = res.data[0];
            } else {
              _this.qrCodeUrl.data = {};
            }
          })
        },

        /*-------------------------------客服------------------------*/
        kefuClick() {
          let landingPageShow = _this.landingPage.url.show;
          if (!landingPageShow.code) {
            Message({type: 'error', message: '当前没有落地页无法展示客服链接'});
            return;
          }
          let landingPageCode = _this.landingPage.url.show.code;
          _this.kefu.listDialog = true;
          kefuList({
            landingPageCode: landingPageCode
          }).then(res => {
            _this.kefu.data = res.data;
          })
        },
        hideKefuList() {
          _this.kefu.listDialog = false;
        },
        switchKefuConfig(item) {
        // 使用change事件，会先更改v-model绑定的值，在调用change事件
        if (item.isAvailable === 0) {
          disableKefu({code: item.code}).then(res => {
            Message({type: 'success', message: '禁用客服链接成功'});
          });
        } else {
          enableKefu({code: item.code}).then(res => {
            Message({type: 'success', message: '启用客服链接成功'});
          });
        }
      },
        linkDialogfun(){
            _this.linkDialog = false
        },
        renameDialogfun(){
            _this.renameDialog = false
        },
        userStatusfun(){
            this.userStatus = false
        },
        dialogVisiblefun(){
            this.dialogVisible = false
        },
        copy(text){
            if (!text) {
              Message({type: 'error', message: '复制文本为空'});
            } else {
              const input = document.createElement("input");
              document.body.appendChild(input);
              input.setAttribute("value", text);
              input.select();
              document.execCommand('copy')
              Message({type: 'success', message: '复制成功'});
              document.body.removeChild(input);
            }
        },
        selectUser(item){
            _this.userId = item.userId;
            _this.username = item.userName;
            _this.init();
            _this.$nextTick(function(){
                _this.userStatus = false;
                _this.chooseUserName = item.userName;
            })
        },
        selectTime(data){
            _this.time.startTime = data[0]
            _this.time.endTime = data[1]
            _this.$nextTick(function(){
                _this.calendarstatus = false
            })
          _this.refreshStatistics();
        },
        qrCodeConfigAddOperation(){
          _this.qrCodeConfig.addData.userName = _this.username;
          _this.qrCodeConfig.addData.fileCode = _this.qrCodeConfig.uploadFileResult.fileCode;
          _this.qrCodeConfig.addData.bigFileCode = _this.qrCodeConfig.uploadFileResult.url;
            addQrCodeConfig(_this.qrCodeConfig.addData)
                .then(res => {
              _this.qrCodeConfig.addDialog = false;
              _this.qrCodeConfig.addData={};
              _this.qrCodeConfig.uploadFileList=[];
              _this.qrCodeConfig.uploadFileResult={};
              _this.groupList();
            })
        },
      qrCodeConfigEditOperation(){
        _this.qrCodeConfig.editData.userName = _this.username;
        _this.qrCodeConfig.editData.fileCode = _this.qrCodeConfig.uploadFileResult.fileCode;
        _this.qrCodeConfig.editData.bigFileCode = _this.qrCodeConfig.uploadFileResult.url;
        editQrCodeConfig(_this.qrCodeConfig.editData)
            .then(res => {
              _this.qrCodeConfig.editDialog = false;
              _this.qrCodeConfig.editData={};
              _this.qrCodeConfig.uploadFileList=[];
              _this.qrCodeConfig.uploadFileResult={};
              _this.groupList();
            })
      },
        selectRecharge(item){
            _this.dialogVisible = false
            let data = {
              userId: _this.userId,
              amount: item.amount,
              deduction: item.deduction,
              payType: 2
            }
            pay(data).then(res => {
              if (res.ok) {
                // 将链接转转换为二维码图片
                _this.qecode = "data:image/gif;base64," + res.data.qrCode;
                _this.qrcodeDialog = true;
              } else {
                Message({type: 'error', message: res.msg});
              }
            })
        },
        buildChartData(data) {
          let chartData = {
            click: [],
            conversion: [],
            xData: []
          };
          for (let i = 0; i < data.length; i++) {
            let eachData = data[i];
            chartData.xData.push(eachData.date);
            chartData.click.push(eachData.clickTimes);
            chartData.conversion.push(eachData.conversionTimes);
          }
          return chartData;
        },
        drawChart(chartData) {
            // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
            let myChart = this.$echarts.init(document.getElementById("charts"));
            // 指定图表的配置项和数据
            let option = {
                backgroundColor: 'white',
                grid: {
                    top: '28%',
                    left: '5%',
                    right: '5%',
                    bottom: '8%',
                    containLabel: true
                },
                title: [{
                    text: '消耗看板',
                    top:'5%',
                    left:'5%',
                    textStyle: { //设置字体样式
                        color: '#606060',
                        fontSize: 12,
                    },
                }, {
                    top:'10%',
                    left:'5%',
                    //subtext: '1388.66',
                    subtextStyle: { //设置字体样式
                        color: '#000000',
                        fontSize: 22,
                    }
                }],
                legend: [{
                    top: '5%',
                    right: '5%',
                    itemWidth: 40,
                    itemHeight: 20,
                    itemGap: 20,
                    data:[{
                        name:'点击数',
                        icon:"image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAYCAYAAACvKj4oAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAFkSURBVFiF1ZdBdoIwEIa/6fMesqjsOEPxZCUnM54hO+3CXqTpouIDRZiEpMi/8T3MMP+fSeYfhJXjvXC1eD47j2oAEczpUjWyDK156Iiqx9aJYFYncLd1ByaEdbEagdeqHULj3nKQSY2ycE2MuFUc0bJwje83ERVW0WQC7pv1ggH4ulS2+8dLCgzpkqdL1YyuSchrFrSirrBeMPfVGsLiAgOFAdjzd7XXvn/RLtrpjrVmvQgmRBwsVMGIqqnu22BcaMBcRBi2+r4NYRMT1OJ+0BXh+AN2jIzoPW2WsFu+mCCN+Q4dKYWvJRHV4xGyOHIetCIcAcY2JfaOTUGgv7PPEoVO8UEkMokDkGfHrU0aO8WrCWQUByC7rfO5Xj6ZPLM4SGP01gt7+Rt2bUhcbnEAGxFMzOcIjx2v/Z3ssv9RuVsuDaGHICXBsnANgPd8tM9S28AUejahEJrcp3Jj0AdfYedT4Ref2MGFtKGJKQAAAABJRU5ErkJggg=="
                    },
                    {
                        name:'转化数',
                        icon:"image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAWCAYAAACL6W/rAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAIWSURBVFiF1Zi/buJAEMa/2U0okEyR5e4SR9fiSEE8ACWC8p4nuTxABM+T1rTUUZRIMa0VpCC2snSWTnj3igTLNotxgg/iX+f1etjZ+eaPIByY84tboWu8OXu48grtPWIOAEBDgNMUAEzfUukn/QD25fBX/MBpmuec3Rk5iHTL+NLwLS/rkB/Fbg+7AOrJtWDu+sa9eU4BgIawvvedhujJYDEOAYCVedii2O1hFxoitchIbtpPf6NFEbuxTHGAiNmdkQOFn6nFLTIMFuPQOhsQNAQIkiJ1T1r7OGZh5oLq1o9+M5i7/t5zLJVXwFanttozyZTTdK8RszsjJyvB2eP1ZBebwasr42iu0BB7y7FNN1uG7dnDlQdCKkePyjBcCINTu0gwCy2Vp2u8CaUFLZVHwPttwtzodmHVfKG0WJPg0/Vdmb+VhcUSiXTrvbeUgt0edjVnXUS6tVbaS5JgHiwlEQ1xfnErcvYXwlQkYkqW4CZYNumSTe6zbGyoe3IKAHjjpPcHjJINs54cTT5DsBiHDdGTOGYhGElaKo+09mdPv40j0//grXhkRxyC3LW/HBoOAKaoWWcDCl5dCbzljPWt71ing/pq7asTj1SmwZQiNdE13kwWGIrU5OX55ss7F08eJunF5bqCpEYqilR+XhFkFaIFZBx7eb6R2fIfU7GCsjbdB3PXX5uWK+YUkPOfR3ICqYr8kvwDk5vyfBVjGN0AAAAASUVORK5CYII="
                    }],
                    textStyle: {
                        color: '#000',
                        fontSize: 14,
                        fontWeight: 400
                    }
                }],
                xAxis: {
                    type: 'category',
                    axisLine: {
                        show: true,
                        lineStyle:{
                            color: '#E0E0E0',
                            type:"dotted"
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine:{
                        show: false,
                    },

                  //文字样式
                    axisLabel: {
                      show: true,
                      textStyle: {
                        color: '#595C61'
                      },
                      // 倾斜展示
                      rotate:45
                    },

                    data: chartData.xData
                },
                yAxis: [
                    {
                        type: 'value',
                        axisLine: {
                            show: false,
                            lineStyle:{
                                color: '#E0E0E0',
                                type:"dotted"
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#E0E0E0',
                                type:"dotted"
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    }
                ],
                series: [
                    {
                        name: '点击数',
                        type: 'line',
                        smooth: true,
                        // showAllSymbol: true, //显示所有图形。
                        //标记的图形为实心圆
                        symbolSize: 4, //标记的大小
                        itemStyle: {
                            //折线拐点标志的样式
                            color: 'white',
                            borderWidth: '1',
                            normal: {
                                color: '#000000',//拐点颜色
                                lineStyle: {
                                    color: '#5470c6'
                                },
                            }
                        },
                        data: chartData.click
                    },
                    {
                        name: '转化数',
                        type: 'line',
                        smooth: true,
                        symbol: 'none', //显示所有图形。
                        symbolSize: 4, //标记的大小
                        itemStyle: {
                            normal: {
                                lineStyle:{
                                    color: '#1A2B88',
                                    type:"dotted"
                                }
                            }
                        },
                        data: chartData.conversion
                    }
                ]
            }
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
        handleClickOutside(){
            _this.userStatus = false
        },
    }

}
</script>

<style lang="less">
    #home{
        .editgroupDialog{
            border-radius: 20px;
            background: rgba(250, 251, 252, 1);
            // border: 2px solid rgba(239, 238, 235, 1);
            // overflow: hidden;
            .el-dialog__body{
                padding: 0px 0 0;
            }
            .qrcode{
                text-align: center;
                img{
                    width: 50%;
                }
            }
            .upload-demo{
                text-align: center;
                margin-bottom: 20px;
                color: #000;
            }
            .form{
                border-top:1px solid #EDF0F2;
                margin-top: 12px;
                padding: 16px 30px 0;
                .formbox{
                    border-radius: 10px;
                    background: #FFFFFF;
                    border: 2px solid #F2F5F7;
                    box-shadow: 0px 5px 10px  #F0F2F5;
                    font-size: 12px;
                    font-weight: 700;
                    color: rgba(152, 164, 178, 1);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 12px;
                    margin-bottom: 12px;
                    position: relative;
                    textarea{
                        border-radius: 5px;
                        border: 1px solid #E4E7F0;
                        outline: none;
                        width:200px;
                        height:69px;
                        padding-left: 8px;
                        font-size: 12px;
                    }
                    input{
                        border-radius: 5px;
                        border: 1px solid #E4E7F0;
                        outline: none;
                        width:200px;
                        height:28px;
                        padding-left: 8px;
                        font-size: 12px;
                    }
                    textarea::placeholder{
                        color: rgba(181, 183, 192, 1);
                    }
                    input::placeholder {
                        color: rgba(181, 183, 192, 1);
                    }
                    img{
                        width: 12px;
                        cursor: pointer;
                    }
                }
                div:last-child{
                    margin-bottom: 0;
                }
            }
            .button{
                display: flex;
                 border-radius: 0 0 20px 20px;
                 overflow: hidden;
                .save{
                    flex: 0 0 50%;
                    background: linear-gradient(180deg, #0077FF 0%, #00AFFF 100%);
                    color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 25px 0;
                    margin-top: 14px;
                    cursor: pointer;
                }
                .del{
                    flex: 0 0 50%;
                    background: linear-gradient(90deg, #FF758C 0%, #FF7EB3 100%);
                    color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 25px 0;
                    margin-top: 14px;
                    cursor: pointer;
                }
            }
        }
        .addgroupDialog{
            border-radius: 20px;
            background: rgba(250, 251, 252, 1);
            position: absolute;
            left: 120%;
            top: 0;
            width: 200px;
            padding: 20px;
            .userboxtitle{
                margin-bottom: 20px;
                font-size: 18px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
            }
            li{
                margin-bottom: 20px;
                font-size: 13px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
                cursor: pointer;
                span{
                    margin-right: 8px;
                }
            }
            li:last-child{
                margin-bottom: 0;
            }

        }
        .addRqcodeDialog{
            border-radius: 20px;
            background: rgba(250, 251, 252, 1);
            // border: 2px solid rgba(239, 238, 235, 1);
            // overflow: hidden;
            .el-dialog__body{
                padding: 0px 0 0;
            }
            .upload-demo{
                width: 80%;
                margin:0 auto;
                opacity: 1;
                border-radius: 8px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 1px 3px  rgba(96, 108, 128, 0.05);
                border:none;
                padding-bottom: 40px;
                .el-upload{
                    width: 100%;
                    border: none;
                    .el-upload-dragger{
                        width: 100%;
                        height: auto;
                        border: none;
                    }
                }
                div{
                    width: 60%;
                    margin:0 auto;
                }
                .el-upload__text{
                    font-size: 12px;
                    font-weight: 700;
                    color: rgba(152, 162, 178, 1);
                }
                .el-upload__tip{
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(230, 223, 223, 1);
                }
                img{
                    width: 30px;
                    margin:30px auto 30px;
                    display: block;
                }
            }
            .form{
                border-top:1px solid #EDF0F2;
                margin-top: 12px;
                padding: 16px 30px 0;
                .formbox{
                    border-radius: 10px;
                    background: #FFFFFF;
                    border: 2px solid #F2F5F7;
                    box-shadow: 0px 5px 10px  #F0F2F5;
                    font-size: 12px;
                    font-weight: 700;
                    color: rgba(152, 164, 178, 1);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 12px;
                    margin-bottom: 12px;
                    position: relative;
                    textarea{
                        border-radius: 5px;
                        border: 1px solid #E4E7F0;
                        outline: none;
                        width:200px;
                        height:69px;
                        padding-left: 8px;
                        font-size: 12px;
                    }
                    input{
                        border-radius: 5px;
                        border: 1px solid #E4E7F0;
                        outline: none;
                        width:200px;
                        height:28px;
                        padding-left: 8px;
                        font-size: 12px;
                    }
                    textarea::placeholder{
                        color: rgba(181, 183, 192, 1);
                    }
                    input::placeholder {
                        color: rgba(181, 183, 192, 1);
                    }
                    img{
                        width: 12px;
                        cursor: pointer;
                    }
                }
                div:last-child{
                    margin-bottom: 0;
                }
            }
            .button{
                background: linear-gradient(180deg, #0077FF 0%, #00AFFF 100%);
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 25px 0;
                margin-top: 14px;
                cursor: pointer;
                border-radius:0 0 20px 20px;
            }
        }


        .qrcodeDialog{
            border-radius: 20px;
            background: rgba(255, 255, 255, 1);
            border: 2px solid rgba(239, 238, 235, 1);
            .el-dialog__title{
                margin-top: 20px;
                display: block;
                font-size: 26px;
                font-weight: 700;
            }
        }
        .scrollMenuBox{
            height: 490px;
        }
        .home{
            display: flex;
            padding-right: 40px;
            .content{
                flex: 1 0 1%;
                position: relative;
            }
            .flexbox{
                position: absolute;
                width: 97%;
                top: -60px;
                left: 0;
                display: flex;
                justify-content: space-between;
                .calendarbox{
                    position: relative;
                    .calendartimebox{
                        border-radius: 12px;
                        background: rgba(246, 246, 246, 1);
                        box-shadow: 2px 2px 7px  rgba(0, 0, 0, 0.25);
                        padding: 10px 10px 10px 10px;
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 1);
                        cursor: pointer;
                        img{
                            width: 16px;
                            margin-top: -2px;
                        }
                    }
                    .zx-calendar{
                        position: absolute;
                        top: 110%;
                        left: 50%;
                        transform: translateX(-50%);
                        z-index: 100;
                    }
                }
                .userbox{
                    position: relative;
                    .msg{
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        .imgbox{
                            width: 37px;
                            height: 37px;
                            opacity: 1;
                            border-radius: 10px;
                            background: rgba(255, 255, 255, 1);
                            box-shadow: 0px 2px 4px  rgba(0, 0, 0, 0.25);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-right: 12px;
                            img{
                                width: 24px;
                            }
                        }
                        span{
                            font-size: 12px;
                            font-weight: 400;
                            letter-spacing: 0px;
                            line-height: 17.38px;
                            color: rgba(0, 0, 0, 1);
                        }
                    }
                    .tc{
                        position: absolute;
                        top: 110%;
                        left: 0;
                        border-radius: 20px;
                        background: rgba(255, 255, 255, 1);
                        border: 2px solid rgba(239, 238, 235, 1);
                        box-shadow: 1px 1px 4px  rgba(0, 0, 0, 0.25);
                        z-index: 100;
                        width:203px;
                        padding: 30px 20px;
                        .userboxtitle{
                            margin-bottom: 20px;
                            font-size: 18px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 1);
                        }
                        li{
                            margin-bottom: 16px;
                            padding: 6px 0;
                            cursor: pointer;
                            span{
                                margin-right: 12px;
                                font-size: 13px;
                                font-weight: 400;
                                color: rgba(0, 0, 0, 1);
                            }
                        }
                        li:hover{
                            border-radius: 5px;
                            background: rgba(229, 229, 229, 1);
                        }
                        .on{
                            border-radius: 5px;
                            background: rgba(229, 229, 229, 1);
                        }
                        .userList{
                          max-height: 240px;
                          overflow-y: auto;
                        }
                        .loadMore{
                          background: #eee;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          font-size: 20px;
                          position: absolute;
                          bottom: 6px;
                          left: 0;
                          width: 100%;
                          border-radius: 0 0 12px 11px;
                          color: #cfcfcf;
                        }
                    }
                }
            }
            .chat{
                display: flex;
                margin-bottom: 40px;
                .chatleft{
                    width:614px;
                    border-radius: 20.37px;
                    background: rgba(255, 255, 255, 1);
                    border: 2px solid rgba(239, 238, 235, 1);
                    box-shadow: 1px 1px 4px  rgba(0, 0, 0, 0.25);
                    margin-right: 33px;
                    overflow: hidden;
                }
                .chatright{
                    flex: 1 0 1%;
                    .chatrightul{
                        display: flex;
                        flex-wrap: wrap;
                        .chatrightli{
                            padding: 14px 20px;
                            width: 203px;
                            height: 154px;
                            opacity: 1;
                            border-radius: 20px;
                            background: rgba(255, 255, 255, 1);
                            border: 2px solid rgba(239, 238, 235, 1);
                            margin-right: 22px;
                            margin-bottom: 22px;
                            .top{
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                margin-bottom: 12px;
                                .topbox{
                                    display: flex;
                                    align-items: center;
                                    position: relative;
                                    .rechargeDialog{
                                        position: absolute;
                                        top: 110%;
                                        left: 0;
                                        border-radius: 20px;
                                        background: rgba(255, 255, 255, 1);
                                        border: 2px solid rgba(239, 238, 235, 1);
                                        z-index: 100;
                                        width:203px;
                                        padding: 30px 20px;
                                        .userboxtitle{
                                            margin-bottom: 20px;
                                            font-size: 18px;
                                            font-weight: 400;
                                            color: rgba(0, 0, 0, 1);
                                        }
                                        ul{
                                            li{
                                                display: flex;
                                                justify-content: space-between;
                                                margin-bottom: 10px;
                                                padding: 4px 8px;
                                                cursor: pointer;
                                                font-size: 14px;
                                                font-weight: 400;
                                                color: rgba(0, 0, 0, 1);
                                            }
                                            li:hover{
                                                border-radius: 5px;
                                                background: linear-gradient(180deg, rgba(230, 233, 240, 1) 0%, rgba(238, 241, 245, 1) 100%);
                                                box-shadow:inset 0px 0px 3px  rgba(0, 0, 0, 0.25);
                                            }
                                        }
                                    }
                                }
                                .tip{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: rgba(235, 12, 12, 1);
                                    margin-left: 6px;

                                }
                            }
                            .name{
                                font-size: 12px;
                                font-weight: 400;
                                letter-spacing: 0.12px;
                                color: rgba(96, 96, 96, 1);
                                margin-bottom: 12px;
                            }
                            .num{
                                font-size: 22px;
                                font-weight: 400;
                                letter-spacing: 0.22px;
                                color: rgba(0, 0, 0, 1);
                            }
                        }
                        .chatrightli:nth-child(2n){
                            margin-right: 0;
                        }
                        .chatrightli:nth-child(n+2){
                            margin-bottom: 0;
                        }
                    }
                    .icon{
                        width: 34px;
                        height: 34px;
                        opacity: 1;
                        border-radius: 12px;
                        background: rgba(232, 232, 232, 1);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img{
                            width: 16px;
                        }
                        i{
                            font-size: 16px;
                            color: rgba(26, 43, 136, 1);
                        }
                    }
                }
            }
            .table{
                display: flex;
                .tableleft{
                    padding: 8px 24px;
                    width: 848px;
                    border-radius: 20.37px;
                    background: rgba(255, 255, 255, 1);
                    border: 2px solid rgba(239, 238, 235, 1);
                    box-shadow: 1px 1px 4px  rgba(0, 0, 0, 0.25);
                    margin-right: 22px;
                    .tabletitle{
                        display: flex;
                        justify-content: space-between;
                        .fun{
                            display: flex;
                            .del{
                                width: 38px;
                                height: 38px;
                                opacity: 1;
                                border-radius: 12px;
                                background: rgba(236, 72, 153, 0.1);
                                box-shadow: 0px 2px 4px  rgba(0, 0, 0, 0.25);
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                font-size: 10px;
                                font-weight: 700;
                                color: rgba(219, 39, 119, 1);
                                margin-right: 10px;
                            }
                            .filterbox{
                                position: relative;
                                .filter{
                                    width: 38px;
                                    height: 38px;
                                    opacity: 1;
                                    border-radius: 12px;
                                    background: rgba(246, 246, 246, 1);
                                    box-shadow: 2px 3px 9px  rgba(0, 0, 0, 0.25);
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    margin-right: 12px;
                                    img{
                                        width: 24px;
                                    }
                                }
                                .groupDialog{
                                    position: absolute;
                                    top: 100%;
                                    left: 0;
                                    border-radius: 20px;
                                    background: rgba(255, 255, 255, 1);
                                    border: 2px solid rgba(239, 238, 235, 1);
                                    z-index: 100;
                                    width:203px;
                                    .groupDialogbox{
                                        position: relative;
                                        padding: 20px 20px;
                                    }
                                    .userboxtitle{
                                        margin-bottom: 20px;
                                        font-size: 18px;
                                        font-weight: 400;
                                        color: rgba(0, 0, 0, 1);
                                        margin-bottom: 12px;
                                    }
                                    .add{
                                        position: absolute;
                                        top: 20px;
                                        right: 16px;
                                        cursor: pointer;
                                        img{
                                            width: 24px;
                                        }
                                    }
                                    .list{
                                        li{
                                            display: flex;
                                            justify-content: space-between;
                                            margin-bottom: 25px;
                                            font-size: 13px;
                                            font-weight: 400;
                                            color: rgba(0, 0, 0, 1);
                                            .msg{
                                                flex:0 0 70%;
                                                display: flex;
                                                justify-content: space-between;
                                                .msgleft{
                                                    flex:0 0 80%;
                                                    span:first-child{
                                                        display: inline-block;
                                                        margin-right: 12px;
                                                    }
                                                }
                                            }
                                            .button{
                                                display: flex;
                                                align-items: center;
                                                .more{
                                                    width: 18px;
                                                    margin-right: 12px;
                                                    cursor: pointer;
                                                }
                                                .delbutton{
                                                    width: 12px;
                                                    cursor: pointer;
                                                }
                                            }
                                        }
                                    }
                                    .renameDialog{
                                        border-radius: 20px;
                                        background: rgba(255, 255, 255, 1);
                                        border: 2px solid rgba(239, 238, 235, 1);
                                        position: absolute;
                                        left: 110%;
                                        top: 0;
                                        overflow: hidden;
                                        padding: 20px 20px;
                                        ul{
                                            display: flex;
                                            justify-content: space-between;
                                            font-size: 13px;
                                            font-weight: 400;
                                            .name{
                                                width: 100px;
                                            }
                                            input{
                                                width: 100px;
                                                border: none;
                                                outline: none;
                                            }
                                        }
                                    }
                                }
                            }
                            .search{
                                width: 302px;
                                height: 44px;
                                border-radius: 12px;
                                background: rgba(255, 255, 255, 1);
                                border: 1px solid rgba(239, 238, 235, 1);
                                box-shadow: 3px 2px 9px  rgba(0, 0, 0, 0.25);
                                display: flex;
                                align-items: center;
                                padding: 10px 16px;
                                img{
                                    width: 24px;
                                }
                                input{
                                    border: none;
                                    outline: none;
                                    padding-left: 13px;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: rgba(181, 183, 192, 1);
                                }
                                input::placeholder {
                                    color: rgba(181, 183, 192, 1);
                                }
                            }
                        }
                        .title{
                            font-size: 18px;
                            font-weight: 800;
                            letter-spacing: 0.18px;
                            color: rgba(0, 0, 0, 1);
                        }
                    }
                    .tablebox{
                        .tableboxtitle{
                            display: flex;
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(96, 96, 96, 1);
                            text-align: center;
                            li{
                                margin-right: 23px;
                            }
                            li:nth-child(1){
                                width: 150px;
                            }
                            li:nth-child(2){
                                width: 89px;
                            }
                            li:nth-child(3){
                                width: 78px;
                            }
                            li:nth-child(4){
                                width: 90px;
                            }
                            li:nth-child(5){
                                width: 70px;
                            }
                            li:nth-child(6){
                                width: 243px;
                                margin-right: 0;
                            }
                        }
                        .line{
                            border-bottom: 1px solid rgba(239, 239, 239, 1);
                            padding-bottom: 12px;
                            margin-top: 30px;
                            margin-bottom: 20px;
                        }
                        .boxshow{
                            margin-bottom: 26px;
                            border-radius: 10px;
                            border: 1px solid rgba(228, 231, 240, 1);
                            padding: 12px 0;
                            position: relative;
                            .on{
                                transform: rotate(90deg);
                            }
                            .show{
                                position: absolute;
                                width: 10px;
                                left: 10px;
                            }
                            .tableboxtitle{
                                font-size: 14px;
                                font-weight: 400;
                                color: rgba(0, 0, 0, 1);
                                align-items: center;
                                text-align: left;
                                padding-left: 36px;
                                .qrcode{
                                    width: 46px;
                                }
                                li:nth-child(4){
                                    text-align: center;
                                    font-size: 12px;
                                }
                                li:nth-child(6){
                                    display: flex;
                                    align-items: center;
                                    justify-content: flex-end;
                                    padding-right: 48px;
                                    img{
                                        width:18px;
                                        margin-left: 27px;
                                        cursor: pointer;
                                    }
                                }
                                li .item {
                                  width: 20px;
                                  height: 20px;
                                }
                            }
                            .childbox{
                                .tableboxtitle{
                                    margin-top: 40px;
                                }
                            }
                        }
                    }
                }
                .tableright{
                    border-radius: 20px;
                    background: rgba(255, 255, 255, 1);
                    border: 1px solid rgba(239, 238, 235, 1);
                    box-shadow: 3px 3px 11px  rgba(0, 0, 0, 0.25);
                    width: 203px;
                    padding: 26px 10px;
                    .title{
                        font-size: 18px;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 1);
                    }
                    .subtitle{
                        font-size: 10px;
                        font-weight: 400;
                        color: rgba(152, 162, 178, 1);
                        margin-top: 12px;
                        margin-bottom: 6px;
                    }
                    .box1{
                        border-radius: 8px;
                        background: rgba(255, 255, 255, 1);
                        border: 1px solid rgba(228, 231, 240, 1);
                        box-shadow: 0px 1px 3px  rgba(96, 108, 128, 0.05);
                        display: flex;
                        font-size: 10px;
                        font-weight: 700;
                        color: rgba(152, 162, 178, 1);
                        padding: 8px 11px 8px 8px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        position: relative;
                        p{
                            width: 86%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .copy{
                            width: 16px;
                            cursor: pointer;
                        }
                        .down{
                            width: 10px;
                            margin-right: 4px;
                            cursor: pointer;
                        }
                        .putinDialog{
                            position: absolute;
                            top: 110%;
                            left: 50%;
                            transform: translateX(-50%);
                            border-radius: 20px;
                            background: rgba(255, 255, 255, 1);
                            border: 2px solid rgba(239, 238, 235, 1);
                            padding: 20px 20px;
                            z-index: 100;
                            width: 368px;
                            li{
                                display: flex;
                                justify-content: space-between;
                                font-size: 12px;
                                font-weight: 400;
                                color: rgba(0, 0, 0, 1);
                                margin-bottom: 8px;
                                img{
                                    width: 16px;
                                    cursor: pointer;
                                    margin-left: 12px;
                                }
                            }
                            li:last-child{
                                margin-bottom: 0;
                            }
                        }
                    }
                    .borderbox{
                        border-radius: 8px;
                        background: rgba(255, 255, 255, 1);
                        border: 1px solid rgba(228, 231, 240, 1);
                        box-shadow: 0px 1px 3px  rgba(96, 108, 128, 0.05);
                        padding: 9px 6px;
                        .box2{
                            font-size: 12px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 1);
                            border-radius: 8px;
                            background: rgba(235, 238, 242, 1);
                            box-shadow: 0px 15px 25px  rgba(38, 51, 77, 0.05);
                            margin-top: 14px;
                            text-align: center;
                            padding: 7px 0;
                            cursor: pointer;
                            position: relative;
                            .linkDialog{
                                border-radius: 20px;
                                background: rgba(255, 255, 255, 1);
                                border: 2px solid rgba(239, 238, 235, 1);
                                padding: 20px 20px;
                                position: absolute;
                                top: 110%;
                                left: 50%;
                                transform: translateX(-50%);
                                width:278px;
                                z-index: 100;
                                li{
                                    display: flex;
                                    justify-content: space-between;
                                    margin-bottom: 8px;
                                    .button{
                                        display: flex;
                                        align-items: center;
                                        .Vector{
                                            width: 18px;
                                            margin-right: 10px;
                                            cursor: pointer;
                                        }
                                        .del{
                                            width: 12px;
                                            margin-left: 10px;
                                            cursor: pointer;
                                        }
                                    }
                                }
                                li:last-child{
                                    margin-bottom: 0;
                                }
                            }
                        }
                        .box3{
                            .title{
                                width: 102px;
                                height: 24px;
                                border-radius: 8px;
                                background: rgba(255, 255, 255, 1);
                                border: 1px solid rgba(228, 231, 240, 1);
                                font-size: 10px;
                                font-weight: 700;
                                color: rgba(31, 38, 51, 1);
                                display: flex;
                                justify-content: center;
                                align-items: center;
                            }
                            .time{
                                margin: 8px 0;
                                font-size: 12px;
                                font-weight: 400;
                                letter-spacing: 0px;
                                line-height: 17.38px;
                                color: rgba(0, 0, 0, 1);
                                .el-select{
                                    border-radius: 8px;
                                    width:60px;
                                    height:24px;
                                    background: rgba(255, 255, 255, 1);
                                    border: 1px solid rgba(228, 231, 240, 1);
                                    box-shadow: 0px 1px 3px  rgba(96, 108, 128, 0.05);
                                }
                                .el-input{
                                    font-size: 12px;
                                }
                                .on{
                                    margin:0 8px;
                                }
                            }
                            .tip{
                                font-size: 12px;
                                font-weight: 400;
                                color: rgba(230, 223, 223, 1);
                            }
                        }
                        .box4{
                            .title{
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                margin-bottom: 6px;
                                .titleSpan{
                                    font-size: 12px;
                                    font-weight: 400;
                                    letter-spacing: 0px;
                                    line-height: 17.38px;
                                    color: rgba(0, 0, 0, 1);
                                }
                                .el-input{
                                    font-size: 12px;
                                }
                            }
                            .tip{
                                font-size: 12px;
                                font-weight: 400;
                                color: rgba(230, 223, 223, 1);
                            }
                        }
                    }
                    .addButton{
                        width: 163px;
                        height: 46.58px;
                        opacity: 1;
                        border-radius: 8px;
                        background: rgba(248, 248, 248, 1);
                        box-shadow: 4px 4px 16px  rgba(0, 0, 0, 0.25);
                        margin:4px auto;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 12px;
                        font-weight: 400;
                        color: rgba(41, 45, 50, 1);
                        cursor: pointer;
                        img{
                            width: 12px;
                            margin-right: 24px;
                        }
                    }
                }
            }
        }
        .ellipsis {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .item {
          margin: 4px;
        }
    }
</style>
